"use client";

import React from "react";
import { KeyboardShortcutsHelp } from "@/components/features/search/keyboard-shortcuts-help";
import { useKeyboardShortcuts } from "@/hooks/use-keyboard-shortcuts";

export function AppLayoutClient({ children }: { children: React.ReactNode }) {
  const { helpOpen, setHelpOpen, shortcuts } = useKeyboardShortcuts();

  return (
    <>
      {children}
      <KeyboardShortcutsHelp open={helpOpen} onClose={() => setHelpOpen(false)} shortcuts={shortcuts} />
    </>
  );
}
